const WarrantyTag = () => <span className="badge text-bg-secondary">Warranty</span>

export default WarrantyTag
